import { Link } from "react-router-dom";
import { ArrowRight, Sparkles, CalendarDays } from "lucide-react";
import { formatCHF } from "@/lib/api";
import { Reveal } from "@/components/Reveal";
import { useSoins, soinDateLabel } from "@/lib/soins";
import { SoinVisuel } from "@/components/SoinVisuel";
import { useLocale } from "@/context/LocaleContext";

export const SoinDuMomentEncart = ({ inline = false }) => {
  const { t } = useLocale();
  const soins = useSoins();
  const soin = soins?.[0];
  if (!soin) return null;
  return (
    <section className={inline ? "mt-12 lg:mt-16" : "max-w-7xl mx-auto px-6 lg:px-10 pt-6 pb-16 lg:pb-20"} data-testid="home-soin-du-moment">
      <Reveal>
        <Link to="/soin" data-testid="home-soin-link"
          className="group relative overflow-hidden flex flex-col md:flex-row bg-earth grain text-sand rounded-2xl border border-terra/40 hover:-translate-y-1 hover:shadow-xl hover:shadow-earth/20 transition-all duration-500">
          <SoinVisuel soin={soin} compact testid="home-soin-visuel" className="md:w-2/5 aspect-[16/9] md:aspect-auto md:min-h-[240px] shrink-0" />
          <div className="relative z-[2] flex-1 p-6 lg:p-10 flex flex-col justify-center gap-3">
            <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-terra inline-flex items-center gap-2"><Sparkles className="w-3.5 h-3.5" /> {t("Soin du moment")}</p>
            <h2 className="font-serif text-2xl md:text-3xl lg:text-4xl leading-tight">{soin.titre}</h2>
            <p className={`inline-flex items-center gap-2 text-sm text-sand/70 ${soin.date_label ? "" : "capitalize"}`}><CalendarDays className="w-4 h-4 text-terra" />{soinDateLabel(soin)}</p>
            <p className="text-sm text-sand/65 leading-relaxed line-clamp-2 max-w-xl">{soin.description}</p>
            <div className="mt-2 flex flex-wrap items-center gap-4">
              <span className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-terra text-earth text-sm tracking-wide group-hover:bg-sand transition-colors duration-300">{t("Je participe au soin")} <ArrowRight className="w-4 h-4" /></span>
              {soin.prix != null && <span className="font-serif text-lg text-terra">{formatCHF(soin.prix)} <span className="text-xs text-sand/60 font-sans">{t("par personne")}</span></span>}
            </div>
          </div>
        </Link>
      </Reveal>
    </section>
  );
};
